import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}
interface ProgressBarProps {
  progress: number;
}

export const Container = styled.div<Props>`
display: flex;
align-items: center;
justify-content: center;
height: 100%;
`;

export const StyleProgress = styled.div<Props>`
background-color: #e3e9f1;
position: relative;
width: 400px;
height: 8px;
border-radius: 4px;
`;

export const BoxProgress = styled.div<Props>`
font-size: 10px;
position: absolute;
padding: 2px 5px;
top: -25px;
display: flex;
align-items: center;
justify-content: center;
color: rgb(41, 47, 59);
border: 1px solid ${(props: Props) => props.theme.palette.neutral._80};
border-radius: 7px;
`;

export const StyleLineProgress = styled.div<ProgressBarProps>`
z-index: 0;
position: absolute;
top: 0;
height: 8px;
border-radius: 7px;
width: ${(props: ProgressBarProps) => props.progress}%;
background: ${(props: Props) => props.theme.palette.neutral._80};
`;
